export interface ConfirmDialogBodyMessage {
  message: string;
  icon?: string;
}

export interface InitialStateConfig {
  headerTitle?: string;
  bodyMessage?: string[] | string | ConfirmDialogBodyMessage | ConfirmDialogBodyMessage[];
  yesButtonValue?: string;
  noButtonValue?: string;
  sizeDialog?: 'sm' | 'lg';
  extraCancelButton?: boolean;
}

export interface ConfirmDialogConfig {
  action: ConfirmDialogActionEnum;
  initialState?: InitialStateConfig;
  accept?: () => void;
  cancel?: () => void;
}

export enum ConfirmDialogActionEnum {
  SHOW,
  HIDE,
  STOP_SUBMITTED,
}
